import React from 'react'
import { PermissionAction, permissionsService, PermissionType } from '../../services/permissions.service'

interface IfPermissionsProps {
  action: PermissionAction
  type: PermissionType
  children: React.ReactNode
}

export const IfPermissions: React.FC<IfPermissionsProps> = ({ action, type, children }) => {
  const hasPermission = permissionsService.currentUserCan(action, type)

  if (!hasPermission) {
    return null
  }

  return <>{children}</>
}

export default IfPermissions
